<ng-container *ngrxLet="vm$ as vm">
  @if (vm.isHelpCenterEnabled) {
    <mp-help-center-button [isZendeskFeedbackActive]="vm.isZendeskFeedbackActive" [isSmall]="isSmall()" />
  }

  @if (vm.isFeedbackEnabled) {
    <mp-feedback-button [isSmall]="isSmall()" />
  }
</ng-container>
